import React, { useState, useEffect } from 'react';
import TabPanel, { a11yProps } from '../../common/Tabs/TabPanel';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import moment from 'moment';
import OrganizationForm from '../OrganizationForm/OrganizationForm';
import AddressAndContacts from '../OrganizationForm/OrganizationTabs/AddressAndContacts/AddressAndContacts';
import Subsidiaries from '../OrganizationForm/OrganizationTabs/Subsidiaries/Subsidiaries';
import Compliance from '../OrganizationForm/OrganizationTabs/Compliance/Compliance';
import Sap from '../OrganizationForm/OrganizationTabs/Sap/Sap';
import Region from '../OrganizationForm/OrganizationTabs/Region/Region';
import Institution from '../OrganizationForm/OrganizationTabs/Institution/Institution';
import Comments from '../OrganizationForm/OrganizationTabs/Comments/Comments';
import ProgressBar from '../../common/ProgressBar/ProgressBar';
import { yupResolver } from '@hookform/resolvers/yup';
import { formDateFormat } from '../../../constants';
import { organizationValidation } from '../OrganizationUtils/organizationValidation';

const OrganizationDetail = () => {
  const [value, setValue] = useState(0);
  const [formLoading, setFormLoading] = useState(true);
  const organizationForm = useSelector((state) => state.organizationForm);
  const {
    orgId,
    orgKey,
    organizationName,
    alternateName,
    accountingContactId,
    facilityCoordinatorContactId,
    parentOrganizationId,
    administrativeContactId,
    invoiceVerificationContactId,
    wCare,
    parole,
    prison,
    other,
    cbp,
    sap,
    stop,
    vendor,
    inactive,
    orgDateCreate,
    orgDateEdit,
    orgCreatedById,
    orgEditedById,
  } = organizationForm;

  const addressAndContactsForm = useSelector(
    (state) => state.addressAndContactsForm
  );
  const {
    address,
    state,
    orgCity,
    zip,
    county,
    countyId,
    sascaRegion,
    postalAddress,
    postalCity,
    postalZip,
    commPhone,
    commFax,
    commEmail,
    commWeb,
    contactList,
  } = addressAndContactsForm;

  const organizationComplianceForm = useSelector(
    (state) => state.organizationComplianceForm
  );
  const { contractAgency, reviewDate, clearDate, complianceDataList } =
    organizationComplianceForm;

  const organizationSapForm = useSelector((state) => state.organizationSapForm);
  const { sapContract, sapCode, sapNum, sapInstitution } = organizationSapForm;

  const organizationInstitutionForm = useSelector(
    (state) => state.organizationInstitutionForm
  );
  const { prisonCode, prisonNumber, orgInstitutionSapList } =
    organizationInstitutionForm;

  const organizationRegionForm = useSelector(
    (state) => state.organizationRegionForm
  );
  const { region } = organizationRegionForm;

  const organizationCommentForm = useSelector(
    (state) => state.organizationCommentForm
  );
  const { comment } = organizationCommentForm;

  const defaultValue = {
    orgId: orgId,
    orgKey: orgKey,
    organizationName: organizationName,
    alternateName: alternateName,
    accountingContactId: accountingContactId ? accountingContactId : '',
    facilityCoordinatorContactId: facilityCoordinatorContactId
      ? facilityCoordinatorContactId
      : '',
    //orgCityOforganizationForm: organizationForm?.orgCity ? organizationForm?.orgCity : '',
    parentOrganizationId: parentOrganizationId ? parentOrganizationId : '',
    administrativeContactId: administrativeContactId
      ? administrativeContactId
      : '',
    invoiceVerificationContactId: invoiceVerificationContactId
      ? invoiceVerificationContactId
      : '',
    wCare: wCare,
    parole: parole,
    prison: prison,
    other: other,
    cbp: cbp,
    sap: sap,
    stop: stop,
    vendor: vendor,
    inactive: inactive,
    orgDateCreate: orgDateCreate,
    orgDateEdit: orgDateEdit,
    orgCreatedById: orgCreatedById ? orgCreatedById : '',
    orgEditedById: orgEditedById ? orgEditedById : '',
    orgId: orgId,
    address: address,
    state: state,
    orgCity: orgCity,
    zip: zip,
    county: county,
    countyId: countyId ? countyId : '',
    sascaRegion: sascaRegion,
    postalAddress: postalAddress,
    postalCity: postalCity,
    postalZip: postalZip,
    commPhone: commPhone,
    commFax: commFax,
    commEmail: commEmail,
    commWeb: commWeb,
    contactList: contactList,
    contractAgency: contractAgency,
    reviewDate: moment(reviewDate).format(formDateFormat),
    clearDate: moment(clearDate).format(formDateFormat),
    complianceDataList: complianceDataList,
    sapContract: sapContract,
    sapCode: sapCode,
    sapNum: sapNum,
    sapInstitution: sapInstitution ? sapInstitution : '',
    sapGender: organizationSapForm?.gender ? organizationSapForm?.gender : '',
    prisonCode: prisonCode,
    prisonNumber: prisonNumber,
    institutionGender: organizationInstitutionForm?.gender
      ? organizationInstitutionForm?.gender
      : '',
    orgInstitutionSapList: orgInstitutionSapList,
    region: region ? region : '',
    comment: comment,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(organizationValidation),
  });
  const { reset, control, register, formState } = useFunction;
  const { errors } = formState;

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.orgId,
    defaultValue.orgKey,
    defaultValue.organizationName,
    defaultValue.alternateName,
    defaultValue.accountingContactId,
    defaultValue.facilityCoordinatorContactId,
    //defaultValue.orgCityOforganizationForm,
    defaultValue.parentOrganizationId,
    defaultValue.administrativeContactId,
    defaultValue.invoiceVerificationContactId,
    defaultValue.wCare,
    defaultValue.parole,
    defaultValue.prison,
    defaultValue.other,
    defaultValue.cbp,
    defaultValue.sap,
    defaultValue.stop,
    defaultValue.vendor,
    defaultValue.inactive,
    defaultValue.orgDateCreate,
    defaultValue.orgDateEdit,
    defaultValue.orgCreatedById,
    defaultValue.orgEditedById,
    defaultValue.orgId,
    defaultValue.address,
    defaultValue.state,
    defaultValue.orgCity,
    defaultValue.zip,
    defaultValue.county,
    defaultValue.countyId,
    defaultValue.sascaRegion,
    defaultValue.postalAddress,
    defaultValue.postalCity,
    defaultValue.postalZip,
    defaultValue.commPhone,
    defaultValue.commFax,
    defaultValue.commEmail,
    defaultValue.commWeb,
    defaultValue.contactList,
    defaultValue.city,
    defaultValue.contractAgency,
    defaultValue.reviewDate,
    defaultValue.clearDate,
    defaultValue.complianceDataList,
    defaultValue.sapContract,
    defaultValue.sapCode,
    defaultValue.sapNum,
    defaultValue.sapInstitution,
    defaultValue.sapGender,
    defaultValue.prisonCode,
    defaultValue.prisonNumber,
    defaultValue.institutionGender,
    defaultValue.orgInstitutionSapList,
    defaultValue.region,
    defaultValue.comment,
  ]);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setTimeout(() => {
      setFormLoading(false);
    }, 700);
  }, [formLoading]);
  const commentsTab =
    sap && prison ? 6 : !sap && prison ? 5 : sap && !prison ? 5 : 4;

  const institutionTab = sap ? 5 : 4;

  return (
    <>
      {formLoading ? (
        <ProgressBar />
      ) : (
        <Box sx={{ width: '100%' }}>
          <Box>
            <OrganizationForm
              control={control}
              defaultValue={defaultValue}
              register={register}
              errors={errors}
              //useFunction={useFunction}
            />
            <Box
              sx={{
                borderBottom: 2,
                borderColor: '#747070',
                padding: '0px 0px 5px 0px',
              }}
            >
              <Tabs
                value={value}
                onChange={handleTabChange}
                aria-label='basic tabs example'
              >
                <Tab label='Address & Contacts' {...a11yProps(0)} />
                <Tab label='Subsidiaries' {...a11yProps(1)} />
                <Tab label='Compliance' {...a11yProps(2)} />
                <Tab label='Region' {...a11yProps(3)} />
                {sap && <Tab label='Sap' {...a11yProps(4)} />}
                {prison && (
                  <Tab label='Institution' {...a11yProps(institutionTab)} />
                )}
                <Tab label='Comments' {...a11yProps(commentsTab)} />
              </Tabs>
            </Box>
          </Box>
          <TabPanel value={value} index={0}>
            <AddressAndContacts
              control={control}
              defaultValue={defaultValue}
              register={register}
              errors={errors}
              useFunction={useFunction}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Subsidiaries />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Compliance
              control={control}
              defaultValue={defaultValue}
              register={register}
              errors={errors}
              useFunction={useFunction}
            />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <Region
              control={control}
              defaultValue={defaultValue}
              register={register}
              useFunction={useFunction}
            />
          </TabPanel>
          {sap && (
            <TabPanel value={value} index={4}>
              <Sap
                control={control}
                defaultValue={defaultValue}
                register={register}
                errors={errors}
                useFunction={useFunction}
              />
            </TabPanel>
          )}
          {prison && (
            <TabPanel value={value} index={institutionTab}>
              <Institution
                control={control}
                defaultValue={defaultValue}
                register={register}
                errors={errors}
                useFunction={useFunction}
              />
            </TabPanel>
          )}
          <TabPanel value={value} index={commentsTab}>
            <Comments
              control={control}
              defaultValue={defaultValue}
              register={register}
              errors={errors}
              useFunction={useFunction}
            />
          </TabPanel>
        </Box>
      )}
    </>
  );
};

export default OrganizationDetail;
